var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rpl-text-label",class:{
  'rpl-text-label--dark': (_vm.theme === 'dark'),
  'rpl-text-label--dark--underline': (_vm.theme === 'dark' && _vm.underline),
  'rpl-text-label--small': (_vm.size === 'small'),
  'rpl-text-label--small--underline': (_vm.size === 'small' && _vm.underline),
  'rpl-text-label--large': (_vm.size === 'large'),
  'rpl-text-label--large--underline': (_vm.size === 'large' && _vm.underline),
  'rpl-text-label--emphasis': _vm.emphasis
}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }